import React, { createContext, useState, useEffect } from "react";
import { userLogin } from "../services/api";
import { getUserToken } from "../utils";

const AuthContext = createContext({});

const AuthProvider = (props) => {
  const [loggedIn, setLoggedIn] = useState(false);

  useEffect(() => {
    if (getUserToken()) {
      setLoggedIn(true);
    }
  }, []);

  const Login = async (dni, password) => {
    const response = await userLogin({dni, password});
    if (response && response.auth) {
      setLoggedIn(true);
      sessionStorage.setItem("CIBA_USER", JSON.stringify(response));
    }
    return response;
  };

  const LogOut = () => {
    setLoggedIn(false);
    sessionStorage.removeItem("CIBA_USER");     
  };

  const authContextValue = {
    Login,
    LogOut,
    loggedIn
  };

  return <AuthContext.Provider value={authContextValue} {...props} />;
};

const useAuth = () => React.useContext(AuthContext);

export { AuthProvider, useAuth };
